(function () {

  'use strict';

  eclipseApp.directive('uteLanguageSelector', ['uteLocale', function (uteLocale) {

    return {
      scope: true,
      replace: true,
      templateUrl: 'modules/components/views/language-selector.html',
      restrict: 'E',
      controller: ['$scope', function ($scope) {

        /**
         * @description view is to bind to this value
         */
        $scope.selectedLanguage = uteLocale.language === 'en' ? 'fr' : 'en';

        /**
         * @description object of options
         * @type {{en: string, fr: string}}
         */
        $scope.languages = {
          en: 'English',
          fr: 'Français'
        };

        /**
         * @description toggles between two languages en/fr
         */
        $scope.changeLanguage = function () {
          if (uteLocale.language === 'en') {
            uteLocale.language = 'fr';
          } else if (uteLocale.language === 'fr') {
            uteLocale.language = 'en';
          }
        };
      }]
    };

  }]);

})();
